import { TheMask } from 'vue-the-mask'
import countTo from 'vue-count-to'

export default {
  TheMask,
  countTo
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/forall/resources/components.js